import { saveAs } from 'file-saver';
import { Semester } from '../types/grades';

export const clearAllData = () => {
  try {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
    return true;
  } catch (error) {
    console.error('Error clearing data:', error);
    return false;
  }
};

export const generateShareableLink = (): string => {
  const allData: Record<string, string> = {};
  
  // Get all localStorage data
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      const value = localStorage.getItem(key);
      if (value) {
        allData[key] = value;
      }
    }
  }

  // Convert to base64
  const jsonString = JSON.stringify(allData);
  const base64Data = btoa(encodeURIComponent(jsonString));
  
  // Create shareable link with data
  const currentUrl = window.location.origin;
  return `${currentUrl}?data=${base64Data}`;
};

export const importFromLink = (link: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      // Extract data parameter from URL
      const url = new URL(link);
      const base64Data = url.searchParams.get('data');
      
      if (!base64Data) {
        throw new Error('No data found in link');
      }

      // Decode base64 and parse JSON
      const jsonString = decodeURIComponent(atob(base64Data));
      const data = JSON.parse(jsonString);

      // Validate and import data
      Object.entries(data).forEach(([key, value]) => {
        if (typeof value === 'string') {
          localStorage.setItem(key, value);
        }
      });

      resolve();
    } catch (error) {
      reject(new Error('Invalid link format'));
    }
  });
};

export const exportData = () => {
  const allData: Record<string, string> = {};
  
  // Get all localStorage data
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      const value = localStorage.getItem(key);
      if (value) {
        allData[key] = value;
      }
    }
  }

  // Create blob and download
  const blob = new Blob([JSON.stringify(allData, null, 2)], {
    type: 'application/json'
  });
  saveAs(blob, 'gpa-calculator-data.json');
};

export const importData = async (file: File): Promise<void> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const content = e.target?.result as string;
        const data = JSON.parse(content);
        
        // Validate data structure
        Object.entries(data).forEach(([key, value]) => {
          if (typeof value === 'string') {
            localStorage.setItem(key, value);
          }
        });
        
        resolve();
      } catch (error) {
        reject(new Error('Invalid data format'));
      }
    };
    
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
};